import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Queue } from '../../models/queue/queue.model';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.scss'],
  standalone: false
})
export class QueueComponent {

  @Input() queue: Queue[];
  @Output() updateQueue = new EventEmitter<{ borrowerIndex: number, position: number }>();
  @Output() removeBorrower = new EventEmitter<number>();
  @Output() clearQueue = new EventEmitter();

  constructor() { }

  reorderDrop(event: CdkDragDrop<string[]>) {
    this.updateQueue.emit({
      borrowerIndex: event.previousIndex,
      position: event.currentIndex
    });
  }

  handleRemoveBorrower(borrowerId: number): void {
    this.removeBorrower.emit(borrowerId);
  }

  handleClearQueue(): void {
    this.clearQueue.emit();
  }

  readableStatus(status: string) {
    return status?.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  }
}
